import { render, staticRenderFns } from "./OrganizationProfileTab.vue?vue&type=template&id=8d850d8e&"
import script from "./OrganizationProfileTab.vue?vue&type=script&lang=ts&"
export * from "./OrganizationProfileTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports